import Button from '@mui/material/Button'
import styled from '@mui/material/styles/styled'

export const StyledButton = styled(Button, {
  name: 'StyledButton',
  slot: 'Root',
  skipSx: true,
})(
  `
  font-size: '14px';
  font-family: 'Source Sans Pro Semibold';
  background-color: theme.palette.common.white;
  margin-left: '8px';
  font-weight:400;
   `,
)
